import cx from "classnames";
import { Desktop, Mobile } from "./Responsive"

export const NavBar = ({tabs, onClick, currentTab = false}) => {
    return <div>
        <Mobile>
            <label htmlFor="tabs" className="sr-only">
                Select a tab
            </label>
            <select
                id="tabs"
                onChange={(e)=> {
                    onClick(e.target.value)
                }}
                name="tabs"
                className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                defaultValue={currentTab ? tabs.find((tab) => tab.href == currentTab).name : null}
            >
                {tabs.map((tab) => (
                    <option key={tab.name} value={tab.href}>{tab.name}</option>
                ))}
            </select>
        </Mobile>
        <Desktop>
            <div className="border-b border-gray-200">
                <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                    {tabs.map((tab) => (
                        <a
                            key={tab.name}
                            href="#"
                            onClick={(e)=>{
                                e.preventDefault()
                                onClick(tab.href)
                            }}
                            className={cx( 'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium', {
                                'border-orange-500 text-orange-500 ' : tab.href == currentTab,
                                'border-transparent text-gray-500 hover:border-gray-300 hover:text-orange-500 ' : tab.href != currentTab
                            })}
                            aria-current={tab.href == currentTab ? 'page' : undefined}
                        >
                            {tab.name}
                        </a>
                    ))}
                </nav>
            </div>
        </Desktop>
    </div>
}